(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-holus-bolus-feature"]) return;
  try {
    
(() => {
  const mounted = new WeakSet();
  function init(root) {
    root.querySelectorAll('[data-holus-carousel]').forEach(track => {
      if (mounted.has(track)) return;
      mounted.add(track);
      const section = track.closest('.thb-pictures');
      const controls = section.querySelector('[data-gallery-controls]');
      const previous = controls.querySelector('[data-gallery-prev]');
      const next = controls.querySelector('[data-gallery-next]');
      const status = controls.querySelector('[data-gallery-status]');
      const items = Array.from(track.children);
      let pending = false;
      function update() {
        pending = false;
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        controls.hidden = end <= 2;
        section.querySelector('.thb-pictures__hint').hidden = end <= 2;
        track.tabIndex = end > 2 ? 0 : -1;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= end - 2;
        const frame = track.getBoundingClientRect();
        const visible = items.map((item, i) => ({rect:item.getBoundingClientRect(), index:i + 1})).filter(item => item.rect.left >= frame.left - 2 && item.rect.right <= frame.right + 2);
        if (visible.length) {
          const value = status.dataset.statusTemplate.replace('[start]', visible[0].index).replace('[end]', visible[visible.length - 1].index);
          if (status.textContent !== value) status.textContent = value;
        }
      }
      function schedule() {
        if (!pending) { pending = true; requestAnimationFrame(update); }
      }
      function go(direction) {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left:direction * (track.clientWidth + gap), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      previous.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));
      track.addEventListener('scroll', schedule, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); go(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault(); track.scrollTo({left:event.key === 'Home' ? 0 : track.scrollWidth, behavior:'auto'});
        }
      });
      const resize = new ResizeObserver(schedule);
      resize.observe(track);
      schedule();
      document.addEventListener('shopify:section:unload', function unload(event) {
        if (!event.target.contains(track)) return;
        resize.disconnect();
        document.removeEventListener('shopify:section:unload', unload);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-home-discovery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tos-home-discovery')) {
    customElements.define('tos-home-discovery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelectorAll('[data-switcher]').forEach(group => {
          const tabs = [...group.querySelectorAll('[data-tab]')];
          const panels = [...group.querySelectorAll('[data-panel]')];
          const select = index => {
            const oldPanel = panels.find(panel => !panel.hidden);
            if (oldPanel === panels[index]) return;
            group.querySelectorAll('[data-tos-fade-copy]').forEach(copy => copy.remove());
            const oldImage = oldPanel?.querySelector('img');
            const copy = oldImage?.cloneNode(true);
            tabs.forEach((tab, i) => {
              tab.setAttribute('aria-selected', String(i === index));
              tab.tabIndex = i === index ? 0 : -1;
              panels[i].hidden = i !== index;
            });
            const newImage = panels[index].querySelector('img');
            if (copy && newImage && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
              const host = newImage.closest('.hd-hero__media, .hd-explorer__image');
              if (host) {
                copy.removeAttribute('id');
                copy.alt = '';
                copy.setAttribute('aria-hidden', 'true');
                copy.setAttribute('data-tos-fade-copy', '');
                host.style.position = 'relative';
                copy.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:1;';
                copy.style.objectFit = getComputedStyle(newImage).objectFit;
                host.append(copy);
                const fade = copy.animate([{opacity:1},{opacity:0}], {duration:420,easing:'ease-out'});
                fade.finished.then(() => copy.remove()).catch(() => copy.remove());
              }
            }
          };
          tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => select(index), options);
            tab.addEventListener('keydown', event => {
              let next = index;
              if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
              else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
              else if (event.key === 'Home') next = 0;
              else if (event.key === 'End') next = tabs.length - 1;
              else return;
              event.preventDefault();
              select(next);
              tabs[next].focus();
            }, options);
          });
        });
        const rail = this.querySelector('[data-rail]');
        const previous = this.querySelector('[data-previous]');
        const next = this.querySelector('[data-next]');
        if (rail && previous && next) {
          const update = () => {
            previous.disabled = rail.scrollLeft < 3;
            next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
          };
          const move = direction => {
            const cards = [...rail.children];
            const currentLeft = rail.getBoundingClientRect().left;
            const offsets = cards.map(card => card.getBoundingClientRect().left - currentLeft + rail.scrollLeft);
            const target = direction > 0 ? offsets.find(x => x > rail.scrollLeft + 5) : [...offsets].reverse().find(x => x < rail.scrollLeft - 5);
            rail.scrollTo({ left: target ?? (direction > 0 ? rail.scrollWidth : 0), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          };
          previous.addEventListener('click', () => move(-1), options);
          next.addEventListener('click', () => move(1), options);
          rail.addEventListener('scroll', update, { ...options, passive: true });
          this.resizeObserver = new ResizeObserver(update);
          this.resizeObserver.observe(rail);
          update();
          this.loadJournal(rail).then(update);
        }
        this.classList.add('is-ready');
      }
      async loadJournal(rail) {
        if (!rail.dataset.journalSource) return;
        try {
          const source = new URL(rail.dataset.journalSource, window.location.origin);
          if (source.origin !== window.location.origin) return;
          const response = await fetch(source, { signal:this.controller.signal, credentials:'same-origin', cache:'no-store' });
          if (!response.ok) return;
          const journal = new DOMParser().parseFromString(await response.text(), 'text/html');
          const seen = new Set();
          const stories = [...journal.querySelectorAll('[data-journal-card]')].map(card => ({
            title:card.querySelector('h2')?.textContent.trim(),
            link:card.querySelector('h2 a')?.getAttribute('href'),
            category:card.querySelector('.tj-index-card__meta > .tj-kicker')?.textContent.trim(),
            date:card.querySelector('time')?.getAttribute('datetime') || '',
            image:card.querySelector('.tj-index-card__image img')
          })).filter(story => {
            if (!story.title || !story.link || !/^\d{4}-\d{2}-\d{2}$/.test(story.date) || story.date > rail.dataset.journalToday) return false;
            const link = new URL(story.link, source);
            if (!['http:', 'https:'].includes(link.protocol) || seen.has(link.href)) return false;
            seen.add(link.href);
            story.link = link.href;
            return true;
          }).sort((a, b) => b.date.localeCompare(a.date)).slice(0, 4);
          if (!stories.length || !this.isConnected) return;
          const arrow = rail.querySelector('.hd-journal__read');
          const cards = stories.map((story, index) => {
            const item = document.createElement('li');
            item.className = 'hd-journal__item';
            const link = document.createElement('a');
            link.href = story.link;
            const media = document.createElement('div');
            media.className = 'hd-journal__image';
            if (story.image) {
              const image = document.createElement('img');
              ['src', 'srcset', 'width', 'height', 'alt'].forEach(attribute => {
                const value = story.image.getAttribute(attribute);
                if (value !== null) image.setAttribute(attribute, value);
              });
              image.sizes = '(min-width: 1156px) 242px, (min-width: 800px) 21vw, (max-width: 410px) 68vw, 280px';
              image.loading = 'lazy';
              media.append(image);
            } else {
              const cover = document.createElement('span');
              cover.className = 'hd-journal__cover';
              cover.textContent = story.title;
              cover.setAttribute('aria-hidden', 'true');
              media.append(cover);
            }
            if (arrow) media.append(arrow.cloneNode(true));
            const meta = document.createElement('div');
            meta.className = 'hd-journal__meta';
            const category = document.createElement('span');
            category.className = 'hd-label';
            category.textContent = story.category || '';
            const number = document.createElement('span');
            number.className = 'hd-number';
            number.textContent = String(index + 1).padStart(2, '0');
            meta.append(category, number);
            const heading = document.createElement('h3');
            heading.textContent = story.title;
            link.append(media, meta, heading);
            item.append(link);
            return item;
          });
          if (rail.contains(document.activeElement)) return;
          rail.replaceChildren(...cards);
          rail.dataset.journalLoaded = 'true';
        } catch {
          return;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-kusama-feature"]) return;
  try {
    
if (!customElements.get('tos-kusama-viewer')) {
  customElements.define('tos-kusama-viewer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const dialog = this.querySelector('dialog');
      const large = dialog.querySelector('img');
      let active = 0;
      let transition;
      this.querySelector('[role="tablist"]').hidden = false;
      panels.forEach((panel, i) => panel.hidden = i !== 0);
      const select = (index) => {
        if (index === active) return;
        if (transition) transition.cancel();
        const previous = panels[active];
        const next = panels[index];
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        panels.forEach(panel => panel.hidden = panel !== next);
        active = index;
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          transition = next.animate([{opacity:0},{opacity:1}], {duration:280,easing:'ease-out'});
        }
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          tabs[next].focus();
          select(next);
        });
      });
      let opener;
      this.querySelectorAll('a.tk-detail-image').forEach(link => {
        link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          opener = link;
          large.src = link.href;
          large.alt = link.querySelector('img').alt;
          dialog.showModal();
        });
      });
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => opener?.focus());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-press-entry"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mounted = new WeakSet();
  function init(root) {
    root.querySelectorAll('[data-press-carousel]').forEach(track => {
      if (mounted.has(track)) return;
      mounted.add(track);
      const section = track.closest('#press-gallery');
      const controls = section.querySelector('[data-gallery-controls]');
      const previous = controls.querySelector('[data-gallery-prev]');
      const next = controls.querySelector('[data-gallery-next]');
      const status = controls.querySelector('[data-gallery-status]');
      const items = Array.from(track.children);
      let pending = false;
      function update() {
        pending = false;
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        controls.hidden = end <= 2;
        section.querySelector('.tpm-entry__gallery-hint').hidden = end <= 2;
        track.tabIndex = end > 2 ? 0 : -1;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= end - 2;
        const frame = track.getBoundingClientRect();
        const visible = items.map((item, i) => ({rect:item.getBoundingClientRect(), index:i + 1})).filter(item => item.rect.left >= frame.left - 2 && item.rect.right <= frame.right + 2);
        if (visible.length) {
          const value = status.dataset.statusTemplate.replace('[start]', visible[0].index).replace('[end]', visible[visible.length - 1].index);
          if (status.textContent !== value) status.textContent = value;
        }
      }
      function schedule() {
        if (!pending) { pending = true; requestAnimationFrame(update); }
      }
      function go(direction) {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left:direction * (track.clientWidth + gap), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      previous.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));
      track.addEventListener('scroll', schedule, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); go(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault(); track.scrollTo({left:event.key === 'Home' ? 0 : track.scrollWidth, behavior:'auto'});
        }
      });
      const resize = new ResizeObserver(schedule);
      resize.observe(track);
      schedule();
      document.addEventListener('shopify:section:unload', function unload(event) {
        if (!event.target.contains(track)) return;
        resize.disconnect();
        document.removeEventListener('shopify:section:unload', unload);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-press-media-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      document.querySelectorAll('[data-press-index]').forEach(root => {
        if (root.dataset.pressReady) return;
        root.dataset.pressReady = 'true';
        const cards = [...root.querySelectorAll('[data-press-card]')];
        const buttons = [...root.querySelectorAll('[data-press-filter]')];
        const search = root.querySelector('[data-press-search]');
        const grid = root.querySelector('[data-press-grid]');
        const status = root.querySelector('[data-press-status]');
        const empty = root.querySelector('[data-press-empty]');
        const reading = root.querySelector('[data-press-reading]');
        const normalize = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const texts = new Map(cards.map(card => [card, normalize(card.textContent)]));
        const categories = new Set(buttons.map(button => button.dataset.pressFilter));
        let active = categories.has(location.hash.slice(1)) ? location.hash.slice(1) : 'all';
        const render = () => {
          const words = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
          let count = 0;
          cards.forEach(card => {
            const visible = (active === 'all' || card.dataset.category === active) && words.every(word => texts.get(card).includes(word));
            card.hidden = !visible;
            if (visible) count += 1;
          });
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pressFilter === active)));
          const filtered = active !== 'all' || words.length > 0;
          grid.classList.toggle('tpm-index__grid--filtered', filtered);
          if (reading) reading.hidden = filtered;
          empty.hidden = count !== 0;
          status.textContent = (count === 1 ? root.dataset.statusOne : root.dataset.statusMany).replace('[count]', String(count));
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          active = button.dataset.pressFilter;
          search.value = '';
          const url = new URL(location.href);
          url.hash = active === 'all' ? '' : active;
          history.pushState(null, '', url);
          render();
        }));
        search.addEventListener('input', render);
        root.querySelector('[data-press-reset]').addEventListener('click', () => {
          active = 'all'; search.value = '';
          const url = new URL(location.href); url.hash = ''; history.replaceState(null, '', url);
          render(); search.focus();
        });
        const restore = () => { active = categories.has(location.hash.slice(1)) ? location.hash.slice(1) : 'all'; render(); };
        window.addEventListener('popstate', restore);
        window.addEventListener('hashchange', restore);
        render();
        root.classList.add('tpm-index--ready');
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-media-forward"]) return;
  try {
    
  (() => {
    const forward = () => {
      const link = document.querySelector('[data-press-forward]');
      if (!link) return;
      const target = new URL(link.href, location.origin);
      target.search = location.search;
      location.replace(target.href);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', forward);
    else forward();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tos-object-detail"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tos-object-detail')) {
  customElements.define('tos-object-detail', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      const tabs = [...this.querySelectorAll('[data-detail-tab]')];
      this.querySelectorAll('[data-detail-image]').forEach(view => {
        const form = view.querySelector('[data-detail-form]');
        if (form) {
          const primary = view.querySelector('[data-detail-primary]');
          const alternate = view.querySelector('[data-detail-alternate]');
          const full = view.querySelector('[data-detail-full]');
          form.hidden = false;
          form.addEventListener('click', () => {
            const showAlternate = form.getAttribute('aria-pressed') !== 'true';
            form.setAttribute('aria-pressed',String(showAlternate));
            primary.hidden = showAlternate; alternate.hidden = !showAlternate;
            form.textContent = showAlternate ? form.dataset.primaryLabel : form.dataset.alternateLabel;
            full.href = showAlternate ? full.dataset.alternateUrl : full.dataset.primaryUrl;
          });
        }
      });
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        this.querySelectorAll('[data-detail-image]').forEach(el => { el.hidden = Number(el.dataset.detailImage) !== index; });
        this.querySelectorAll('[data-detail-panel]').forEach(el => { el.hidden = Number(el.dataset.detailPanel) !== index; });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
      });
      this.addEventListener('shopify:block:select', event => { const index = tabs.indexOf(event.target.closest('[data-detail-tab]')); if (index >= 0) select(index); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tos-selection"]) return;
  try {
    
if(!customElements.get('tos-selection')) customElements.define('tos-selection',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;
  this.abort=new AbortController();const options={signal:this.abort.signal};
  const key='tos-selection-v1';const labels=JSON.parse(this.querySelector('[data-selection-labels]').textContent);
  const isPage=this.hasAttribute('data-selection-page'),dialog=this.querySelector('[data-selection-surface]'),list=this.querySelector('[data-selection-list]'),summary=this.querySelector('[data-selection-summary]');
  let pieces=[],opener=null;
  const confirmation=this.querySelector('[data-selection-confirmation]');
  const confirmed=!!confirmation&&!this.querySelector('[data-selection-errors]')&&(confirmation.dataset.serverSuccess==='true'||new URLSearchParams(location.search).get('selection_result')==='sent');
  if(confirmed){
   confirmation.hidden=false;
   const fields=this.querySelector('[data-selection-fields]');fields.hidden=true;fields.disabled=true;
   this.querySelector('[data-selection-form-intro]').hidden=true;
  }
  const request=this.querySelector('[data-selection-request]'),viewing=this.querySelector('[data-selection-viewing]'),message=this.querySelector('#TosSelectionMessage');
  const updateRequest=()=>{if(!request)return;const isViewing=request.value==='Private viewing request';viewing.hidden=!isViewing;viewing.disabled=!isViewing;message.required=!isViewing;message.placeholder=isViewing?labels.viewing_hint:labels.enquiry_hint;this.querySelector('[data-selection-message-label]').textContent=isViewing?labels.viewing_message:labels.enquiry_message;this.querySelector('[data-selection-send]').textContent=isViewing?labels.viewing_send:labels.enquiry_send;};
  if(request){if(new URLSearchParams(location.search).get('request')==='viewing')request.value='Private viewing request';request.addEventListener('change',updateRequest,options);updateRequest();}
  const clean=items=>Array.isArray(items)?items.map(p=>p&&typeof p.url==='string'?{...p,url:p.url.split(/[?#]/)[0]}:p).filter(p=>p&&/^\d+$/.test(p.id)&&typeof p.title==='string'&&typeof p.url==='string'&&/^\/products\/[a-z0-9-]+$/.test(p.url)).slice(0,30).map(p=>({id:p.id,title:p.title.slice(0,250),url:p.url,image:typeof p.image==='string'&&/^(https:)?\/\/(cdn\.shopify\.com|threeoversix\.com)\//.test(p.image)?p.image:''})):[];
  const storageError=()=>{this.querySelector('[data-selection-storage]').hidden=false};
  try{pieces=clean(JSON.parse(localStorage.getItem(key)||'[]'))}catch{storageError()}
  const announce=text=>{this.querySelector('[data-selection-status]').textContent=text};
  const syncButtons=()=>{
   document.querySelectorAll('[data-tos-save]').forEach(b=>{const saved=pieces.some(p=>p.id===b.dataset.pieceId);b.hidden=false;b.setAttribute('aria-pressed',String(saved));b.querySelector('[data-save-label]').textContent=saved?labels.saved:labels.save});
   document.querySelectorAll('[data-tos-selection-open]').forEach(b=>{b.hidden=false;b.setAttribute('aria-label',labels.title+', '+pieces.length+' '+(pieces.length===1?labels.count_one:labels.count));const c=b.querySelector('[data-selection-count]');c.hidden=!pieces.length;c.textContent=pieces.length});
  };
  const render=()=>{
   list.replaceChildren();
   pieces.forEach(p=>{const li=document.createElement('li'),img=document.createElement('img'),text=document.createElement('div'),a=document.createElement('a'),remove=document.createElement('button');
    img.alt='';img.width=80;img.height=100;img.loading='lazy';if(p.image)img.src=p.image;else img.hidden=true;
    a.href=p.url;a.textContent=p.title;remove.type='button';remove.textContent=labels.remove;remove.dataset.selectionRemove=p.id;remove.setAttribute('aria-label',labels.remove+' '+p.title);text.append(a,remove);li.append(img,text);list.append(li)});
   this.querySelector('[data-selection-empty]').hidden=!!pieces.length;
   this.querySelector('[data-selection-note]').hidden=!pieces.length;
   this.querySelector('[data-selection-enquiry]').hidden=!pieces.length&&!confirmed&&!this.querySelector('[data-selection-errors]');
   if(summary)summary.value=pieces.map((p,i)=>(i+1)+'. '+p.title+'\n'+location.origin+p.url).join('\n\n');syncButtons();
  };
  const persist=()=>{try{localStorage.setItem(key,JSON.stringify(pieces))}catch{storageError()}render()};
  const open=button=>{opener=button;render();if(isPage){dialog.scrollIntoView({block:'start'});this.querySelector('#TosSelectionTitle').focus()}else if(!dialog.open)dialog.showModal()};
  document.addEventListener('click',e=>{
   const button=e.target.closest('[data-tos-save]');if(button){e.preventDefault();const id=button.dataset.pieceId;const exists=pieces.some(p=>p.id===id);if(exists){pieces=pieces.filter(p=>p.id!==id);announce(labels.removed)}else{if(pieces.length>=30){announce(labels.limit);return}const next=clean([{id,title:button.dataset.pieceTitle,url:button.dataset.pieceUrl,image:button.dataset.pieceImage}]);if(!next.length)return;pieces.push(next[0]);announce(labels.added)}persist();return}
   const trigger=e.target.closest('[data-tos-selection-open]');if(trigger){e.preventDefault();open(trigger)}
  },options);
  this.addEventListener('click',e=>{if(e.target.closest('[data-selection-close]'))dialog.close();const remove=e.target.closest('[data-selection-remove]');if(remove){const index=pieces.findIndex(p=>p.id===remove.dataset.selectionRemove);pieces=pieces.filter(p=>p.id!==remove.dataset.selectionRemove);persist();announce(labels.removed);const remaining=list.querySelectorAll('button');(remaining[Math.min(index,remaining.length-1)]||this.querySelector('[data-selection-close]')||this.querySelector('#TosSelectionTitle')).focus()}},options);
  dialog.addEventListener('click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dialog.close()}},options);
  dialog.addEventListener('close',()=>opener?.focus(),options);
  this.querySelector('form')?.addEventListener('submit',e=>{if(confirmed||!pieces.length){e.preventDefault();return}if(summary)summary.value=pieces.map((p,i)=>(i+1)+'. '+p.title+'\n'+location.origin+p.url).join('\n\n');if(request.value==='Private viewing request'&&!message.value.trim())message.value=labels.viewing_send;},options);
  window.addEventListener('storage',e=>{if(e.key===key){try{pieces=clean(JSON.parse(e.newValue||'[]'));render()}catch{}}},options);
  this.observer=new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-tos-save], [data-tos-selection-open]')||n.querySelector('[data-tos-save], [data-tos-selection-open]')))))syncButtons()});
  this.observer.observe(document.body,{childList:true,subtree:true});render();
  if(confirmed){confirmation.scrollIntoView({block:'center'});confirmation.focus({preventScroll:true})}else if(this.querySelector('[data-selection-errors]'))open(null);
 }
 disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();
})();
